// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-laser-removal-treatments',
//   imports: [],
//   templateUrl: './laser-removal-treatments.html',
//   styleUrl: './laser-removal-treatments.css',
// })
// export class LaserRemovalTreatments {

// }





import { CommonModule, isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import {
  Component,
  OnInit,
  CUSTOM_ELEMENTS_SCHEMA,
  PLATFORM_ID,
  Inject,
  ChangeDetectorRef,
} from '@angular/core';

@Component({
  selector: 'app-laser-removal-treatments',
  standalone: true,
  imports: [CommonModule, HttpClientModule],
 templateUrl: './laser-removal-treatments.html',
  styleUrl: './laser-removal-treatments.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  host: { ngSkipHydration: 'true' },
})
export class LaserRemovalTreatments implements OnInit {
  categoryGroups: any[] = [];
  loading = true;
  errorMessage = '';
  imageBaseUrl = 'https://crm-api.redmonkwellness.com';
  apiUrl = 'https://crm-api.redmonkwellness.com/Treatment/GetTreatment';

  private readonly allowedCategoryKeywords = [
    'laser & removal',
    'laser and removal',
    'laser removal',
    'laser hair reduction',
    'hair reduction',
    'laser hair removal',
    'hair removal',
    'mole removal',
    'mole',
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.loadTreatments();
  }

  loadTreatments(): void {
    this.http.post<any>(this.apiUrl, {}).subscribe({
      next: (res) => {
        const filteredTreatments = (res.TreatmentHistory || []).filter((item: any) =>
          //this.matchesAllowedCategory(item.Category || item.TreatmentName)
            this.matchesAllowedCategory(item.Category) && Number(item.IsActive) === 0
        );

        if (res.success) {
          this.categoryGroups = this.groupByCategory(filteredTreatments);
        } else {
          this.errorMessage = res.message || 'Unable to load treatments.';
        }

        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error(err);
        this.errorMessage = 'Unable to load treatments. Please try again later.';
        this.loading = false;
        this.cdr.detectChanges();
      },
    });
  }

  private matchesAllowedCategory(category: string): boolean {
    if (!category) {
      return false;
    }

    const normalized = category.toLowerCase();
    return this.allowedCategoryKeywords.some((keyword) => normalized.includes(keyword));
  }

  groupByCategory(list: any[]): any[] {
    const map = new Map<string, any[]>();

    for (const t of list) {
      const key = t.Category || 'Other';
      if (!map.has(key)) map.set(key, []);
      map.get(key)!.push(t);
    }

    return Array.from(map.entries()).map(([category, treatments]) => ({
      category,
      treatments,
      loop: false,
    }));
  }

  trackById(_index: number, item: any): number {
    return item.ID;
  }

  setDefaultImage(event: Event): void {
    const element = event.target as HTMLImageElement;
    element.src = '/assets/images/treatments/no-image.jpg';
  }
}

